export default __webpack_public_path__ + "static/media/赛马会.51c8a1f1.jpg";